import React from 'react'
import {
  BAlert,
  BButton,
  BLink,
  BCol,
  BForm,
  BRow,
  BText,
  BTitle,
  BIcon,
} from '@prague-digi/ui-components'

import messages from '../../../../i18n'
import { BTextInput, mapResponseToErrorResponse, SmsError } from '../../../../components'
import { SmsVerifyResponse } from '../../../../constants'
import { SmsSendResponse } from '../../../../types'

interface Props {
  close: Function
  didSendFirstSms: boolean
  phone: string
  sendSms: Function
  smsSendResponse: SmsSendResponse
  smsVerifyResponse?: SmsVerifyResponse
  translate: Function
  verifySms: Function
}

export const SmsForm = ({
  close,
  didSendFirstSms,
  phone,
  sendSms,
  smsSendResponse,
  smsVerifyResponse,
  translate,
  verifySms,
}: Props) => {
  const { sent, nextAttemptAvailable } = smsSendResponse
  const errorResponse = mapResponseToErrorResponse(smsVerifyResponse)
  const alertMessage = sent
    ? messages.smsVerify.sendResponse.smsSent
    : messages.smsVerify.sendResponse.usePreviousCode

  if (errorResponse) {
    return (
      <div data-test-id="verify-sms-error">
        <SmsError
          sendSms={sendSms}
          nextAttemptAvailable={nextAttemptAvailable}
          variant={errorResponse}
          translate={translate}
        />
      </div>
    )
  }

  return (
    <BForm component="div">
      <BRow>
        <BCol>
          <BTitle type="h3">{translate(messages.smsVerify.title)}</BTitle>
        </BCol>
        <BCol theme="col-auto">
          <BButton onClick={close} theme="close float-right">
            <BIcon name="close" theme="float-right mr-0" />
          </BButton>
        </BCol>
      </BRow>
      {didSendFirstSms && (
        <BRow>
          <BCol>
            <BAlert color="warning" noIcon>
              {translate(alertMessage, { phone })}
            </BAlert>
          </BCol>
        </BRow>
      )}
      <BText type="notice" theme="pb-0 mb-1 mt-4 font-weight-bold">
        {translate(messages.smsVerify.insertCode)}
      </BText>
      <BRow>
        <BCol>
          <BTextInput
            autoFocus
            name="verificationCode"
            tabIndex={0}
            testid="verificationCode"
            theme="w-100"
          />
        </BCol>
        <BCol theme="col-sm-auto mt-5 mt-sm-0" xs={12}>
          <BButton
            messages={{
              message: translate(messages.smsVerify.sign),
            }}
            type="button"
            color="primary"
            disabled={!sent}
            testid="submitButton"
            size="lg"
            onClick={verifySms}
            tabIndex={0}
            theme="w-100"
          />
        </BCol>
      </BRow>
      {nextAttemptAvailable && (
        <BRow theme="mt-3">
          <BCol>
            <BLink onClick={sendSms}>{translate(messages.smsVerify.newSms)}</BLink>
          </BCol>
        </BRow>
      )}
    </BForm>
  )
}

export default SmsForm
